export default __webpack_public_path__ + "static/media/group-white.3ccb6193.png";